import { Link } from "react-router-dom";
import Seo from "@/lib/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page introuvable" path="/404" />
      <section className="py-24 sm:py-32 text-center" data-testid="not-found-page">
        <p className="eyebrow mb-4">Erreur 404</p>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight uppercase text-onyx">
          Ballon dehors.
        </h1>
        <p className="mt-5 text-muted-foreground">Cette page n'existe pas ou a été déplacée.</p>
        <Link to="/" data-testid="not-found-home"
          className="mt-8 inline-block bg-rouge text-white px-8 py-4 text-sm font-bold uppercase tracking-wide hover:bg-rouge-hover transition-colors">
          Retour à l'accueil
        </Link>
      </section>
    </>
  );
}
